var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-chat"},[_c('chat-header',{ref:"headerRef",staticClass:"header"}),_c('chat-body',{ref:"bodyRef",staticClass:"body",style:(_vm.bodyStyle)}),_c('chat-footer',{ref:"footerRef",staticClass:"footer",on:{"openMenu":_vm.openMenu}}),_c('image-previewer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }